import React, { useState, createContext, useContext } from 'react';
import { useAuth } from './AuthProvider';
import { useNavigate } from 'react-router-dom';

const C = { turquesa:'#5dc1b9', mango:'#FDBE02', coral:'#eb636b' };
const font = "'DM Sans', sans-serif";
const LABELS = { free_observer:'Free Observer', tu_radar:'Tu Radar', doer:'Doer', spark_seeker:'Doer', momentum_builder:'Momentum Builder', growth_mastermind:'Growth Mastermind', clarity_mentor:'Clarity Mentor', onsite_mexico:'Onsite México' };

const PreviewCtx = createContext({ unlockAll: false, setUnlockAll: () => {} });

export function PreviewProvider({ children }) {
  const [unlockAll, setUnlockAll] = useState(true);
  return <PreviewCtx.Provider value={{ unlockAll, setUnlockAll }}>{children}</PreviewCtx.Provider>;
}

export function usePreviewMode() {
  const { isAdmin, viewAs } = useAuth();
  const { unlockAll, setUnlockAll } = useContext(PreviewCtx);
  const isPreview = isAdmin && !!viewAs;
  return { isPreview, unlockAll: isPreview && unlockAll, toggleStudentView: () => setUnlockAll(v => !v) };
}

export default function PreviewBanner() {
  const { isAdmin, viewAs, setViewAs } = useAuth();
  const { unlockAll, setUnlockAll } = useContext(PreviewCtx);
  const navigate = useNavigate();
  if (!isAdmin || !viewAs) return null;

  return (
    <div style={{
      background: 'linear-gradient(135deg, #534AB720, #1D9E7520)',
      border: '1.5px solid #534AB740', borderRadius: 14, padding: '10px 16px',
      marginBottom: 16, display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap',
    }}>
      <span style={{ fontSize: 16 }}>👑</span>
      <p style={{ fontSize: 13, margin: 0, flex: 1, fontFamily: font, minWidth: 120 }}>
        <strong>Modo Preview</strong> — Viendo como <strong style={{ color: C.turquesa }}>{LABELS[viewAs] || viewAs}</strong>
        {unlockAll ? ' (todo desbloqueado)' : ' (vista alumno)'}
      </p>
      <button onClick={() => setUnlockAll(v => !v)} style={{
        background: unlockAll ? C.turquesa + '20' : C.mango + '20',
        color: unlockAll ? C.turquesa : C.mango,
        border: 'none', borderRadius: 50, padding: '5px 14px', fontSize: 11,
        fontWeight: 600, cursor: 'pointer', fontFamily: font,
      }}>
        {unlockAll ? '🔒 Ver como alumno' : '🔓 Desbloquear todo'}
      </button>
      <button onClick={() => { setViewAs(null); setTimeout(() => navigate('/admin'), 50); }} style={{
        background: C.coral, color: '#fff', border: 'none', borderRadius: 50,
        padding: '5px 14px', fontSize: 11, fontWeight: 600, cursor: 'pointer', fontFamily: font,
      }}>← Admin</button>
    </div>
  );
}
